import React from 'react';
import MyAccountPage from '../Components/MyAccount/MyAccountPage';

const MyAccount = () => {
  return <MyAccountPage />;
};

export default MyAccount;
